function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Heart({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.612 5c-.03 0-1.482.014-2.506 1.037-.733.732-1.104 1.835-1.104 3.28-.006.14-.078 1.982 1.808 3.953l7.07 6.377L19 13.219c1.835-1.92 1.762-3.761 1.758-3.84 0-1.507-.373-2.61-1.106-3.342C18.626 5.01 17.17 5 17.154 5c-3.017 0-4.365 2.122-4.42 2.213-.185.295-.557.487-.86.476a1 1 0 01-.853-.483C10.97 7.123 9.621 5 6.612 5m5.267 16.993a.996.996 0 01-.67-.258l-7.79-7.033C.831 12.006.995 9.355 1.004 9.243c-.003-1.936.574-3.524 1.712-4.646C4.35 2.987 6.532 3.003 6.627 3c2.611 0 4.322 1.203 5.253 2.13.931-.927 2.646-2.13 5.266-2.13.084-.007 2.262-.013 3.895 1.596 1.138 1.122 1.716 2.71 1.716 4.72.005.038.17 2.689-2.365 5.335l-7.843 7.084a.996.996 0 01-.67.258",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoHeart = React.memo(Heart);
export default MemoHeart;